<nav class="navbar-default navbar-static-side">
	<div class="sidebar-collapse">
		<ul class="nav" id="side-menu">
			<li class="nav-header">
				<div class="dropdown profile-element">
					<span style="display: flex; align-items: center">
						<img alt="image" src="assets/images/CAASS_LOGO_NEW.png" width="121" height="48" />
						<span style="font-size: 10px; color: white; margin-top: 20px">v{{ VersionText }}</span>
					</span>
				</div>
				<div class="logo-element">CAASS</div>
			</li>

			<li routerLinkActive="inactive">
				<!--Normal Category-->
				<a href=""><i class="fa" class="fa fa-question-circle"></i> <span class="nav-label">Help</span><span class="fa arrow"></span></a>
				<ul class="nav nav-second-level collapse" routerLinkActive="inactive">
					<li routerLinkActive="active">
						<a href="https://www.access411.com/online-support/" target="_blank">
							<span class="nav-label">Contact Support</span>
						</a>
					</li>
					<li routerLinkActive="active">
						<a href="https://caass.com/" target="_blank">
							<span class="nav-label">User Manual</span>
						</a>
					</li>
				</ul>
			</li>

			<li routerLinkActive="inactive" style="padding: 0px 20px 0px 25px">
				<input
					[disabled]="IsLoading() == true"
					type="text"
					class="form-control"
					placeholder="Search For"
					[(ngModel)]="SearchFor"
					(ngModelChange)="onSearchForChange($event)"
				/>
			</li>

			<!-- <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" *ngIf="!express" >
                <a routerLink="">
                    <i class="fa fa-home"></i> <span class="nav-label">Home</span>
                </a>
            </li> -->

			<li *ngFor="let ap of applicationItemList" [style.display]="ap.FilterShow == false ? 'none' : 'block'" routerLinkActive="inactive">
				<!--Dividers-->
				<span *ngIf="ap.IsSingleItem == true && ap.ApplicationItemKey == '*'" class="nav-label" style="color: #a7b1c2; padding: 0px 0px 0px 5px">{{
					ap.ApplicationItemName
				}}</span>

				<!--Parent that isn't a category like School Search or Visitor Dashboard-->
				<a
					[disabled]="IsLoading() == true"
					*ngIf="ap.IsSingleItem == true && ap.ApplicationItemKey != 'Favorites' && ap.ApplicationItemKey != '*'"
					[routerLink]="ap.RouterLink"
					(click)="onClickSingleItem(ap)"
					><i class="fa" [ngClass]="ap.IconName"></i> <span class="nav-label">{{ ap.ApplicationItemName }}</span></a
				>

				<!--Favorites w/ no items-->
				<a [disabled]="IsLoading() == true" *ngIf="ap.IsSingleItem == true && ap.ApplicationItemKey == 'Favorites'" href=""
					><i class="fa" [ngClass]="ap.IconName"></i> <span class="nav-label">{{ ap.ApplicationItemName }}</span
					><span class="fa arrow"></span
				></a>
				<ul *ngIf="ap.IsSingleItem == true && ap.ApplicationItemKey == 'Favorites'" class="nav nav-second-level collapse" routerLinkActive="inactive">
					<li style="min-height: 32px"></li>
				</ul>

				<!--Normal Category-->
				<a [disabled]="IsLoading() == true" *ngIf="ap.IsSingleItem == false" href=""
					><i class="fa" [ngClass]="ap.IconName"></i> <span class="nav-label">{{ ap.ApplicationItemName }}</span
					><span *ngIf="ReportInboxCount > 0 && ap.ApplicationItemKey == 'InboxReport'" class="ReportInboxSpan">{{ ReportInboxCount }}</span>
					<span class="fa arrow"></span
				></a>
				<ul *ngIf="ap.IsSingleItem == false" class="nav nav-second-level collapse" routerLinkActive="inactive">
					<li routerLinkActive="active" *ngFor="let childApp of ap.Children" [style.display]="childApp.FilterShow == false ? 'none' : 'block'">
						<!--Under favorites category, include a minus button to delete the item from the list-->
						<div *ngIf="childApp.Children.length == 0 && ap.ApplicationItemKey == 'Favorites'" class="FavoriteButtonGrid">
							<button
								[disabled]="ReloadingMenu == true || Searching == true"
								class="btn btn-danger DeleteButton"
								*ngIf="ap.ApplicationItemKey == 'Favorites'"
								(click)="onUnFavorite(childApp.ApplicationItemID)"
							>
								<!-- <i class="fa fa-minus-circle" style="margin: 0px;" aria-hidden="true"></i> -->
								<i class="fa fa-times-circle" style="margin: 0px" aria-hidden="true"></i>
							</button>

							<a [disabled]="IsLoading() == true" *ngIf="childApp.ExternalLink == true" [href]="childApp.RedirectURL" class="LinkText">{{
								childApp.ApplicationItemName
							}}</a>
							<a [disabled]="IsLoading() == true" *ngIf="childApp.ExternalLink != true" [routerLink]="childApp.RouterLink" class="LinkText">{{
								childApp.ApplicationItemName
							}}</a>
						</div>

						<!--Create normal link if the childApp has no sub-items-->
						<!--External Link to Custom Site-->
						<a
							[disabled]="IsLoading() == true"
							*ngIf="childApp.Children.length == 0 && ap.ApplicationItemKey != 'Favorites' && childApp.ExternalLink == true"
							[href]="childApp.RedirectURL"
						>
							{{ childApp.ApplicationItemName }}
						</a>

						<!--Internal Link-->
						<a
							[disabled]="IsLoading() == true"
							*ngIf="childApp.Children.length == 0 && ap.ApplicationItemKey != 'Favorites' && childApp.ExternalLink != true"
							[routerLink]="childApp.RouterLink"
						>
							{{ childApp.ApplicationItemName }}
							<span *ngIf="ReportInboxCount > 0 && childApp.ApplicationItemKey == 'InboxReport|Inbox'" class="ReportInboxSpan">{{
								ReportInboxCount
							}}</span>
						</a>

						<!--Else Create a label and list of sub-items-->
						<a [disabled]="IsLoading() == true" *ngIf="childApp.Children.length > 0" style="cursor: pointer">
							{{ childApp.ApplicationItemName }}
							<span class="fa arrow"></span>
						</a>
						<ul *ngIf="childApp.Children.length > 0" class="nav nav-second-level collapse" routerLinkActive="inactive">
							<div *ngIf="childApp.Children.length > 0" style="background-color: #3e495f">
								<a [disabled]="IsLoading() == true" href="#">
									<hr
										class="nav-label nav-second-level"
										style="color: white; background-color: #3e495f; width: 60%; margin-top: -5px; margin-bottom: -15px; margin-left: 52px"
									/>
								</a>
							</div>
							<li
								style="background-color: #3e495f"
								routerLinkActive="inactive"
								*ngFor="let innerChild of childApp.Children"
								[style.display]="innerChild.FilterShow == false ? 'none' : 'block'"
							>
								<a
									[disabled]="IsLoading() == true"
									*ngIf="innerChild.ApplicationItemName != 'Inbox' || InboxCount == 0"
									role="button"
									(click)="getLink(innerChild, innerChild.ExternalLink)"
								>
									{{ innerChild.ApplicationItemName }}
								</a>

								<a
									[disabled]="IsLoading() == true"
									*ngIf="innerChild.ApplicationItemName == 'Inbox' && InboxCount > 0"
									role="button"
									(click)="getLink(innerChild, innerChild.ExternalLink)"
								>
									<div class="InboxGrid">
										{{ innerChild.ApplicationItemName }}
										<div class="alert alert-danger InboxCount">
											{{ InboxCount }}
										</div>
									</div>
								</a>
							</li>
							<div *ngIf="childApp.Children.length > 0" style="background-color: #3e495f">
								<a [disabled]="IsLoading() == true" href="#">
									<hr
										class="nav-label nav-second-level"
										style="color: white; background-color: #3e495f; width: 60%; margin-top: -15px; margin-bottom: -5px; margin-left: 52px"
									/>
								</a>
							</div>
						</ul>
					</li>
				</ul>
			</li>
		</ul>
	</div>
</nav>
